import React, { Component } from 'react';
import '@divina/styles/dist/css/styles.css';
import CalculatorComp from '@divina/calculator/lib';
import config from '../../config/config.json';
import BudgetSender from '../BudgetSender';
import Comercio from '../Comercio';

const getProductTheme = (product) => {
  for (let i = 0; i < config.families.length; i++) {
    for (let j = 0; j < config.families[i].products.length; j++) {
      if (config.families[i].products[j] === product) {
        return config.families[i].theme;
      }
    }
  }
};

class Calculator extends Component {
  constructor(props) {
    super(props);
    const agentId = props.agentId;
    this.state = {
      calculatorForm: {},
      agentId: agentId,
    };
  }
  onCalculatorFormChange = (value) => {
    this.setState({
      calculatorForm: value,
    });
  };

  render() {
    const product = this.props.match.params.product;

    return (
      <div>
        {product !== 'comercio' ? (
          <div className={`theme-${getProductTheme(product)}`}>
            <div className="main-title">
              <div className="main-title__content">
                <div className="main-title__text">
                  Calcula cuanto te costaría tu{' '}
                  {config.products[product].productInfo.name}
                </div>
                <span
                  className={`main-title__icon icon icon--${config.products[product].productInfo.theme}`}
                />
              </div>
            </div>
            <CalculatorComp
              product={product}
              onFormChange={this.onCalculatorFormChange}
              actionComponent={
                <BudgetSender
                  calculatorForm={this.state.calculatorForm}
                  product={product}
                  agentId={this.state.agentId}
                />
              }
            />
          </div>
        ) : (
          <Comercio product={product} />
        )}
      </div>
    );
  }
}

export default Calculator;



// WEBPACK FOOTER //
// ./src/components/Calculator/index.js